/* ═══════════════════════════════════════════════════════════
   js/booking-modal.js — общая модалка брони квартиры (владелец 2026-07-17).

   ДВЕ точки входа (обе — CTA из ee627fd5):
     1) Кнопка «Забронировать» в панели квартиры (flat-overlay.js) на jk.php/flats.php —
        открывает модалку ПОВЕРХ панели, не уходя со страницы. href оставлен как
        progressive-enhancement / SEO fallback (Ctrl-клик / средняя кнопка навигируют).
     2) Плашка «Забронировать» у цены на flat.php (#flatPriceBook) — тоже модалка
        (aside-форма на странице сохранена как fallback).

   Форма МИНИМАЛЬНАЯ (владелец капсом): имя · телефон · чекбокс согласия 152-ФЗ · submit.
   Никаких email/комментариев/лишних полей. Honeypot _hp обязателен.

   Payload map_api.php?action=apply — тот же, что рабочая aside-форма flat.js:
     {name, phone, _hp, flat_id, building_id, building_name, type:'booking',
      source, consent_main, comment}. Бэкенд (MapHandler::apply) строит метку по type
      (whitelist 'booking'→flat_booking), а `comment` дописывается в notes как контекст
      «откуда» — whitelist type НЕ ломается.

   Тёмная+золото: ТОЛЬКО самоимённые классы booking-modal__* (инцидент 17.07:
   catalog.css переопределяет всю семью .modal-* на страницах каталога/квартиры —
   переиспользование глобальных имён отравлено) + .form-group/.form-checkbox/.submit-button/
   .form-success (components.css) — обе таблицы глобальные/precache, поэтому модалка
   полностью стилизована на всех 3 страницах без нового CSS-файла. Доп. правила
   (.booking-modal z-index поверх flat-overlay 9999, контекст-подзаголовок, ошибка) —
   в main.css.

   Consent-гейт: форма создаётся ДИНАМИЧЕСКИ, а глобальный initConsentGate (shared.js)
   один раз пробегает по DOM на init и её НЕ видит. Поэтому у модалки СВОЙ гейт в submit-
   обработчике (паттерн flat.js): без галочки → preventDefault + window.showConsentHint
   (та же .consent-hint) + фокус чекбокса, отправки нет. Форма помечена
   data-consent-gate-skip для явности. Покрыто tests/JS/booking-modal.test.js.

   z-index стек: .flat-overlay=9999 (панель квартиры — сама модалка) → .booking-modal=10001
   рисуется ПОВЕРХ, свой backdrop не конфликтует (отдельный корневой узел на body).
   ═══════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  const esc = window.escHtml || (s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])));

  function fmtArea(a) {
    const n = parseFloat(a);
    if (!isFinite(n) || n <= 0) return '';
    return (n % 1 === 0 ? n.toFixed(0) : n.toFixed(1));
  }
  function roomsLabel(r) {
    const n = parseInt(r, 10);
    if (!isFinite(n)) return '';
    return n === 0 ? 'Студия' : n + '-комн.';
  }
  function isReserved(ctx) {
    if (!ctx) return false;
    if (ctx.reserved === true) return true;
    return String(ctx.status || '') === 'reserved';
  }

  // Маска телефона +7 (той же формы, что глобальный .phone-input в shared.js). Локальная,
  // т.к. модалка динамическая — глобальный обработчик привязан на init и её input не видит.
  function maskPhone(v) {
    let d = String(v == null ? '' : v).replace(/\D/g, '');
    if (d.startsWith('8')) d = '7' + d.slice(1);
    if (!d.startsWith('7')) d = '7' + d;
    d = d.slice(0, 11);
    let o = '+7';
    if (d.length > 1) o += ' (' + d.slice(1, 4);
    if (d.length >= 5) o += ') ' + d.slice(4, 7);
    if (d.length >= 8) o += '-' + d.slice(7, 9);
    if (d.length >= 10) o += '-' + d.slice(9, 11);
    return o;
  }

  // Контекст «откуда» дописывается в notes бэкендом (MapHandler::apply → comment).
  function buildComment(ctx) {
    const label = ctx && ctx.context_label ? String(ctx.context_label) : '';
    return label ? ('Источник: ' + label) : '';
  }

  // Тело заявки — то же, что рабочая aside-форма flat.js (не ломаем backend-контракт).
  // consent_main шлём ТОЛЬКО когда юзер сам отметил (хардкод = фикция согласия, 152-ФЗ).
  function buildPayload(ctx, fields) {
    ctx = ctx || {};
    fields = fields || {};
    const body = {
      name: fields.name || '',
      phone: fields.phone || '',
      _hp: fields.hp || '',
      flat_id: ctx.flat_id,
      building_id: ctx.building_id,
      building_name: ctx.building_name,
      type: 'booking',
      source: ctx.source || 'flat_booking',
    };
    const comment = buildComment(ctx);
    if (comment) body.comment = comment;
    if (fields.consent) body.consent_main = '1';
    return body;
  }

  // Контекст-подзаголовок: «ЖК N · 2-комн., 42 м²» (данные из flat-объекта / FLAT).
  function buildContextHtml(ctx) {
    ctx = ctx || {};
    const bits = [];
    if (ctx.building_name) bits.push('<b>' + esc(String(ctx.building_name)) + '</b>');
    const spec = [roomsLabel(ctx.rooms), fmtArea(ctx.area) ? fmtArea(ctx.area) + ' м²' : ''].filter(Boolean).join(', ');
    if (spec) bits.push(esc(spec));
    return bits.length ? '<p class="booking-modal__context">' + bits.join(' · ') + '</p>' : '';
  }

  const TITLE_BOOK = 'Забронировать';
  const TITLE_RESERVED = 'Узнать о похожих';

  let modalEl = null;
  let lastFocused = null;

  function focusables() {
    if (!modalEl) return [];
    return Array.prototype.slice.call(
      modalEl.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]):not([hidden]), [tabindex]:not([tabindex="-1"])')
    );
  }

  function onKey(e) {
    if (!modalEl) return;
    if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
    if (e.key === 'Tab') {
      const f = focusables();
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      const active = (modalEl.ownerDocument || document).activeElement;
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    }
  }

  function close() {
    if (!modalEl) return;
    document.removeEventListener('keydown', onKey, true);
    modalEl.remove();
    modalEl = null;
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (_e) { /* noop */ }
    }
    lastFocused = null;
  }

  function showError(msg) {
    if (!modalEl) return;
    const box = modalEl.querySelector('.booking-modal__err');
    if (box) { box.textContent = msg; box.classList.add('is-visible'); }
  }
  function hideError() {
    if (!modalEl) return;
    const box = modalEl.querySelector('.booking-modal__err');
    if (box) { box.textContent = ''; box.classList.remove('is-visible'); }
  }

  function open(ctx) {
    ctx = ctx || {};
    // Одна модалка за раз (повторный клик по другой квартире — пересоздаём).
    if (modalEl) close();
    lastFocused = (document.activeElement && typeof document.activeElement.focus === 'function') ? document.activeElement : null;

    const reserved = isReserved(ctx);
    const title = reserved ? TITLE_RESERVED : TITLE_BOOK;
    const sub = reserved
      ? 'Оставьте заявку — предложим похожие и сообщим, если освободится'
      : 'Оставьте заявку — перезвоним за 5 минут';

    modalEl = document.createElement('div');
    modalEl.className = 'booking-modal active';
    modalEl.id = 'bookingModal';
    modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    modalEl.setAttribute('aria-labelledby', 'bookingModalTitle');
    modalEl.innerHTML =
      '<div class="booking-modal__content">'
      + '<div class="booking-modal__header">'
      + '<div class="booking-modal__head">'
      + '<h2 class="booking-modal__title" id="bookingModalTitle">' + esc(title) + '</h2>'
      + buildContextHtml(ctx)
      + '</div>'
      + '<button class="booking-modal__close" type="button" data-bm-close aria-label="Закрыть">&times;</button>'
      + '</div>'
      + '<div class="booking-modal__body">'
      + '<p class="booking-modal__sub">' + esc(sub) + '</p>'
      + '<div class="booking-modal__err" role="alert" aria-live="assertive"></div>'
      + '<form class="booking-modal__form" novalidate data-consent-gate-skip>'
      + '<div class="form-group">'
      + '<label for="bmName">Ваше имя *</label>'
      + '<input type="text" id="bmName" name="name" placeholder="Иван Иванов" autocomplete="name" required>'
      + '</div>'
      + '<div class="form-group">'
      + '<label for="bmPhone">Телефон *</label>'
      + '<input type="tel" id="bmPhone" name="phone" class="phone-input ym-hide-content" data-ym-disable-keys="true" placeholder="+7 (___) ___-__-__" autocomplete="tel" required>'
      + '</div>'
      + '<input type="text" name="_hp" class="booking-modal__hp" tabindex="-1" autocomplete="off" aria-hidden="true" hidden>'
      + '<div class="form-checkbox booking-modal__consent">'
      + '<input type="checkbox" id="bmConsent" name="consent_main" value="1" class="checkbox-input" required aria-required="true">'
      + '<label for="bmConsent" class="checkbox-label">Согласен на обработку моих персональных данных (имя, телефон). <a href="/soglasie.php" target="_blank" rel="noopener">Согласие на обработку ПДн</a>.</label>'
      + '</div>'
      + '<button type="submit" class="submit-button booking-modal__submit"><i class="fa-solid fa-calendar-check"></i> Отправить заявку</button>'
      + '</form>'
      + '</div>'
      + '</div>';

    document.body.appendChild(modalEl);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey, true);

    // Backdrop-клик (по фону модалки, не по контенту) — закрыть.
    modalEl.addEventListener('click', e => { if (e.target === modalEl) close(); });
    const closeBtn = modalEl.querySelector('[data-bm-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Маска телефона (свой listener — глобальный .phone-input не видит динамический input).
    const phone = modalEl.querySelector('#bmPhone');
    if (phone) phone.addEventListener('input', () => { phone.value = maskPhone(phone.value); });

    const form = modalEl.querySelector('.booking-modal__form');
    const consent = modalEl.querySelector('#bmConsent');
    if (consent) consent.addEventListener('change', () => { if (consent.checked && typeof window.hideConsentHint === 'function') window.hideConsentHint(consent); });
    if (form) form.addEventListener('submit', e => onSubmit(e, ctx, form, consent));

    // Автофокус имени (не тянет скролл — модалка уже во вьюпорте).
    const nameInput = modalEl.querySelector('#bmName');
    if (nameInput) { try { nameInput.focus(); } catch (_e) { /* noop */ } }
  }

  async function onSubmit(e, ctx, form, consent) {
    e.preventDefault();
    hideError();

    // Собственный consent-гейт (152-ФЗ ст. 9 ч. 4): без галочки — видимая подсказка,
    // отправки нет. Динамическую форму глобальный initConsentGate не перехватывает.
    if (consent && !consent.checked) {
      if (typeof window.showConsentHint === 'function') window.showConsentHint(consent);
      else showError('Отметьте согласие на обработку персональных данных');
      return;
    }

    const fd = new FormData(form);
    const phoneDigits = String(fd.get('phone') || '').replace(/\D/g, '');
    if (phoneDigits.length !== 11) {
      showError('Введите корректный номер телефона');
      const p = form.querySelector('#bmPhone');
      if (p) { try { p.focus(); } catch (_e) { /* noop */ } }
      return;
    }

    const body = buildPayload(ctx, {
      name: fd.get('name'),
      phone: fd.get('phone'),
      hp: fd.get('_hp'),
      consent: !!(consent && consent.checked),
    });

    const btn = form.querySelector('button[type=submit]');
    if (btn) { btn.disabled = true; btn.textContent = 'Отправка...'; }

    try {
      const res = await fetch('/map_api.php?action=apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data && data.ok) {
        if (typeof ymGoal === 'function') ymGoal('booking_form_submit');
        renderSuccess();
      } else {
        if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-calendar-check"></i> Отправить заявку'; }
        showError((data && data.error) || 'Ошибка отправки. Попробуйте ещё раз.');
      }
    } catch (_err) {
      if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-calendar-check"></i> Отправить заявку'; }
      showError('Ошибка сети. Проверьте соединение или позвоните 8 (919) 170-19-18.');
    }
  }

  function renderSuccess() {
    if (!modalEl) return;
    const bodyEl = modalEl.querySelector('.booking-modal__body');
    if (!bodyEl) return;
    bodyEl.innerHTML =
      '<div class="form-success active booking-modal__success">'
      + '<div class="success-icon"><i class="fa-solid fa-check"></i></div>'
      + '<h3>Заявка отправлена!</h3>'
      + '<p>Перезвоним за 5 минут.</p>'
      + '</div>';
    const closeBtn = modalEl.querySelector('[data-bm-close]');
    if (closeBtn) { try { closeBtn.focus(); } catch (_e) { /* noop */ } }
  }

  window.openBookingModal = open;
  window.closeBookingModal = close;

  // Экспорт чистых функций для behavioral-тестов (паттерн window.BroniFlatOverlay).
  window.BroniBookingModal = {
    open: open,
    close: close,
    maskPhone: maskPhone,
    buildPayload: buildPayload,
    buildContextHtml: buildContextHtml,
    isReserved: isReserved,
  };
})();
